export default "__VITE_ASSET__CC8_TSY0__"